import { render, staticRenderFns } from "./forgotten.vue?vue&type=template&id=49a07bb4&scoped=true"
import script from "./forgotten.vue?vue&type=script&lang=js"
export * from "./forgotten.vue?vue&type=script&lang=js"
import style0 from "./forgotten.vue?vue&type=style&index=0&id=49a07bb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a07bb4",
  null
  
)

export default component.exports